import React from "react";
import { useHistory, useParams } from "react-router";
import PageHeader from "Components/Pages/Header";
import Breadcrumb from "Components/Shared/Breadcrumb";
import { Button } from "Components/Button";
import { Loader } from "Components/Loader";
import { createToast } from "Utils/toastFunc";
import { useMutation, useQuery } from "react-query";
import {
  ProductRulesFormValues,
  showProductRule,
  updateProductRule,
} from "Requests/ProductsRules";
import { ProductRulesForm } from "../ProductRulesForm";
import * as S from "../../Partners/styles";

export const EditProductRules = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();

  const { data: ruleSet, isLoading } = useQuery({
    queryKey: ["product-rule", id],
    queryFn: () => showProductRule(Number(id)),
    enabled: !!id,
    refetchOnWindowFocus: false,
  });

  const updateProductRuleMutation = useMutation({
    mutationFn: updateProductRule,
    onSuccess: () => {
      createToast("success", "Regras atualizadas com sucesso");
      history.push("/regras/regras-produtos/lista");
    },
    onError: (errors: string[]) => {
      errors.forEach((error: string) => createToast("error", error));

      createToast("error", "Não foi possível atualizar as regras");
    },
  });

  const initialValues: ProductRulesFormValues | null = ruleSet
    ? {
        product: ruleSet.product_id
          ? { id: ruleSet.product_id, product: ruleSet.product_name }
          : { id: 0, product: "" },
        synonyms: ruleSet.synonyms || "",
        rules: (ruleSet.rules ?? []).map((r: any) => ({
          client_id: r.client_id,
          substitutions: r.substitutions.map((s: any) => ({
            sku: s.product_sku,
            product: s.product_name,
            id: s.product_id,
          })),
        })),
      }
    : null;

  const handleSubmit = async (values: ProductRulesFormValues) => {
    if (!id) return;
    try {
      const payload = {
        product_id: values.product?.id ? values.product?.id : null,
        synonyms: values.synonyms,
        rules: values.rules.map((rule) => ({
          client_id: rule.client_id,
          substitutions: rule.substitutions.map(
            (substitution) => substitution.id
          ),
        })),
      };

      await updateProductRuleMutation.mutateAsync({
        productId: Number(id),
        payload,
      });
    } catch {
      createToast("error", "Não foi possível atualizar as regras");
    }
  };

  if (isLoading || !id) {
    return (
      <S.Container className="entry-app-content">
        <div className="content-holder">
          <div
            style={{ display: "flex", justifyContent: "center", padding: 48 }}
          >
            <Loader />
          </div>
        </div>
      </S.Container>
    );
  }

  if (!ruleSet || !initialValues) {
    return (
      <S.Container className="entry-app-content">
        <div className="content-holder">
          <p className="text-gray">Regra não encontrada.</p>
          <Button
            outlined
            borderRadius="111"
            onClick={() => history.push("/regras/regras-produtos/lista")}
          >
            Voltar
          </Button>
        </div>
      </S.Container>
    );
  }

  return (
    <S.Container className="entry-app-content">
      <div className="content-holder">
        <div>
          <div className="wrapper-header-content">
            <PageHeader title="Editar regras">
              <Breadcrumb
                list={[
                  {
                    path: "/regras/regras-produto",
                    label: "Regras Produto",
                    current: false,
                  },
                  {
                    path: "/regras/regras-produtos/lista",
                    label: "Visualizar regras",
                    current: false,
                  },
                  {
                    path: `/regras/regras-produto/editar/${id}`,
                    label: "Editar regras",
                    current: true,
                  },
                ]}
              />
            </PageHeader>
            <div className="buttons-container">
              <Button
                outlined
                borderRadius="111"
                onClick={() => history.push("/regras/regras-produtos/lista")}
              >
                Cancelar
              </Button>
              <Button
                form="product-rules-form"
                type="submit"
                borderRadius="111"
                loading={updateProductRuleMutation.isLoading}
              >
                Salvar
              </Button>
            </div>
          </div>
        </div>

        <main>
          <div className="form">
            <ProductRulesForm
              initialValues={initialValues}
              onSubmit={handleSubmit}
            />
          </div>
        </main>
      </div>
    </S.Container>
  );
};

export default EditProductRules;
